import * as React from 'react';
import { Datagrid, ImageField, ListProps, ReferenceField, TextField } from 'react-admin';
import './CoachGuideDatagrid.scss';
import { TranslateField } from '../components/TranslateField';

export const CoachGuideDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="coach-guides-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<ImageField source="imageUrl" label="IMAGE"/>
			<TextField source="videoUrl" label="YOUTUBE_LINK"/>
			<TextField source="externalUrl" label="EXTERNAL_LINK"/>
			<TextField source="title" label="TITLE"/>
			<TextField source="description" label="DESCRIPTION"/>
			<ReferenceField source="categoryId" reference="coach-guide-categories" label="CATEGORY">
				<TextField source="name"/>
			</ReferenceField>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
